import { Settings } from "../config/global-settings";
import { useLocation } from "react-router-dom";
import { languageList } from "../../languages";
import config from "../config/global.config.json";
import { contentApi } from "../config/axios-config";
import * as Sentry from "@sentry/browser";
import { ANALYTICS_LOGIN, ANALYTICS_LOGOUT } from "../config/api-urls";

export const SET_STORAGE = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
};

export const GET_STORAGE = (key) => {
    return JSON.parse(localStorage.getItem(key));
};

export const REMOVE_STORAGE = (key) => {
    localStorage.removeItem(key);
};

/*
43 INCH = "Mozilla/5.0 (SMART-TV; Linux; Tizen 3.0) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/2.0 Chrome/47.0.2526.69 TV safari/537.36"
32 INCH = "Mozilla/5.0 (SMART-TV; Linux; Tizen 2.4.0) AppleWebKit/538.1 (KHTML, like Gecko) SamsungBrowser/1.1 TV Safari/538.1"
*/

export const browserDetector = () => {
    const UA = window.navigator.userAgent.toLowerCase();

    if (navigator.userAgent.match(/Tizen/i)) {
        const OS = UA.substring(UA.indexOf("tizen"), UA.indexOf(")")).replace(/ /gi, "-").replace(/\./gi, "-");

        const BROWSER = UA.substring(UA.indexOf("samsung")).split(" ")[0].replace(/\//gi, "-").replace(/\./gi, "-");

        document.documentElement.className += `tizen ${OS} ${BROWSER}`;
    }
};

export const windowResize = () => {
    const zoom = Math.sqrt(window.innerWidth / 1920);
    document.querySelector("html").style.zoom = zoom;
    document.querySelector("#root").style.zoom = zoom;
};

export const getPageSettings = state => {
    if (state === undefined) {
        state = Settings;
    }

    if (state === undefined) {
        state = Settings;
    }

    let settings = state?.pageList?.filter(page => {
        return page?.path === window.location.pathname;
    });

    if (Object.keys(settings)?.length === 0) {
        settings = state?.global?.initialValues;
    } else {
        settings = settings[0]?.settings;
    }

    return settings;
};

export const setFontSize = currentSize => {
    return `${currentSize - currentSize * 0.2}px`;
};

export const arrayLastItem = arr => {
    return arr[arr?.length - 1];
};

export const removeEventIds = () => {
    Object.keys(localStorage).map(key => {
        if (key.match(/pinnedMatchIds_/i)) {
            localStorage.removeItem(key);
        }
    });
};

export const singlePageAutoRefresh = (pageChangeTime, cb) => {
    return setInterval(() => {
        cb();
    }, pageChangeTime * 1000);
};

export const filterProgramMarkets = data => {

    if (!data) {
        return;
    }

    let markets = JSON.parse(JSON.stringify(data));

    const pushLimit = (market, subObj) => {
        const outcomes = subObj ? market[subObj]?.outcomes : market?.outcomes;
        const lastItem = outcomes?.pop(outcomes?.length - 1);
        outcomes.push({
            name: translateKey("eventDetails.limit"),
            showOutcomeNo: "0",
            cssClass: "limit",
            showOdd: subObj ? market[subObj]?.limit : market?.limit
        });
        outcomes.push(lastItem);
        return market;
    };
    const pushHandicap = (market) => {
        const handicap = (position) => {
            let oddValue;

            if (market?.isHandicap === true && position === "first") {
                oddValue = market?.limit;
            } else if (market?.isHandicap === false && position === "last") {
                oddValue = market?.limit;
            } else {
                oddValue = "-";
            }
            return {
                name: translateKey("eventDetails.handicap"),
                showOutcomeNo: Math.floor(Math.random() * Math.floor(1000)),
                cssClass: "limit",
                showOdd: oddValue
            };
        };
        market.outcomes = [handicap("first"), ...(market?.outcomes || []), handicap("last")];
        return market;
    };

    return markets?.map((market) => {
        if (market?.limit !== undefined && market?.isHandicap !== undefined) {
            market = pushHandicap(market);
        }
        if (market?.limit && market?.isHandicap === undefined) {
            pushLimit(market);
        }
        if (market?.relationalMarket !== undefined && market?.relationalMarket?.limit && market?.isHandicap === undefined) {
            pushLimit(market, "relationalMarket");
        }
        return market;
    });

};

export const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

/* context ile ilişkisi olmayan dosyalarda kullanabilmek için fonksiyonu dışarıya aldık */
export const translateKey = (key, values) => {
    const currentLanguage = GET_STORAGE("currentLanguage") || config.defaultLanguage;

    let currentKey;
    const keys = key?.split(".");

    keys.forEach((i) => {
        if (!currentKey) {
            currentKey = languageList[currentLanguage][i];
        } else {
            currentKey = currentKey[i];
        }
    });

    if (values && currentKey?.match(/{[0-9]}/g)) {
        values.forEach((value, i) => {
            currentKey = currentKey.replace(RegExp("\\{" + (i) + "\\}", "g"), value);
        });
    }

    return currentKey || `[${key}]`;

};

export const sendAnalytics = (key) => {

    let api;

    switch (key) {
        case "login": {
            api = ANALYTICS_LOGIN;
            break;
        }
        case "logout": {
            api = ANALYTICS_LOGOUT;
            break;
        }
    }

    return contentApi
    .get(api)
        .catch((error) => {
            console.error(error);
            Sentry.captureException(error);
        });
}

export const timingReloadPage = (time) => {
    setTimeout(()=> {
        window.location.reload()
    }, time)
}
